import Home from './Home';

const routes = [
	{
		path: '/',
		component: { template: '<router-view/>' },
		children: [
			{
				path: '',
				name: 'home',
				component: Home
			}
		]
	}
];

export default routes;
